import { XMarkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

export interface Tag {
  id: string | number;
  label: string;
  value: string;
}

interface TagListProps {
  tags: Tag[];
  onRemove?: (tag: Tag) => void;
  className?: string;
  disabled?: boolean;
}

export function TagList({
  tags,
  onRemove,
  className,
  disabled,
}: TagListProps): JSX.Element {
  return (
    <div className={clsx('flex flex-wrap gap-2', className)}>
      {tags.map((tag) => (
        <span
          key={tag.id}
          className={clsx(
            'inline-flex items-center justify-center rounded-md',
            'h-8',
            'px-2 py-1',
            'gap-1',
            'font-normal text-sm leading-5',
            'bg-[var(--Color-Neutral-Fill-colorFillTertiary,rgba(0,0,0,0.04))]',
            disabled ? 'text-[#8C8C8C]' : 'text-[#141414]',
          )}
        >
          {tag.label}
          {!disabled && onRemove && (
            <button
              type="button"
              onClick={() => onRemove(tag)}
              className="ml-1 rounded-sm outline-none"
            >
              <XMarkIcon
                className={clsx(
                  'h-3.5 w-3.5',
                  disabled ? 'text-[#8C8C8C]' : 'text-[#141414]',
                )}
              />
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
